import {
  QueryClient,
  QueryClientProvider,
  QueryClientProviderProps
} from '@tanstack/react-query';
import React from 'react';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
      cacheTime: 60000,
      staleTime: 60000,
      retry: false
    }
  }
});

export function ReactQueryClientProvider({
  client,
  ...props
}: Omit<QueryClientProviderProps, 'client' | 'context'> & {
  client?: QueryClientProviderProps['client'];
}) {
  return <QueryClientProvider client={client || queryClient} {...props} />;
}
